'use strict';

require('./bootstrap');
require('./services/ModalService');